export default "__VITE_ASSET__10f95295__"